module.exports = __webpack_public_path__ + "img/hz-xtx.f955fc54.png";